import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7a0a68af")

_pushScopeId("data-v-7a0a68af")
const _hoisted_1 = { class: "workflow" }
const _hoisted_2 = { class: "p-grid" }
const _hoisted_3 = { class: "p-col" }
const _hoisted_4 = { class: "kn-list-item-text" }
const _hoisted_5 = { class: "kn-list-item-text-secondary" }
const _hoisted_6 = { class: "p-col" }
const _hoisted_7 = { class: "kn-list-item-text" }
const _hoisted_8 = { class: "kn-list-item-text-secondary" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_Button = _resolveComponent("Button")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
          start: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.mondrianSchemasManagement.workFlow.availableUsers')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Listbox, {
          class: "kn-list workflowContainer",
          options: _ctx.availableUsersList[0],
          filter: true,
          filterPlaceholder: _ctx.$t('common.search'),
          optionLabel: "name",
          filterMatchMode: "contains",
          filterFields: _ctx.workflowDescriptor.filterFields,
          emptyFilterMessage: _ctx.$t('common.info.noDataFound'),
          "data-test": "userList1"
        }, {
          empty: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
          ]),
          option: _withId((slotProps) => [
            _createVNode("div", {
              class: ["kn-list-item", { disableCursor: _ctx.isStartedWf }],
              onClick: ($event: any) => (_ctx.addUserToWfList(slotProps.option.id)),
              "data-test": "userList1-item"
            }, [
              _createVNode("div", _hoisted_4, [
                _createVNode("span", null, _toDisplayString(slotProps.option.userId), 1),
                _createVNode("span", _hoisted_5, _toDisplayString(slotProps.option.fullName), 1)
              ])
            ], 10, ["onClick"])
          ]),
          _: 1
        }, 8, ["options", "filterPlaceholder", "filterFields", "emptyFilterMessage"])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
          start: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.mondrianSchemasManagement.workFlow.userWf')), 1)
          ]),
          end: _withId(() => [
            _withDirectives(_createVNode("span", null, [
              _createVNode(_component_Button, {
                disabled: _ctx.disableButton,
                icon: "pi pi-play",
                class: "p-button-rounded",
                onClick: _ctx.startWorkflow
              }, null, 8, ["disabled", "onClick"])
            ], 512), [
              [
                _directive_tooltip,
                _ctx.$t(_ctx.tooltipValue),
                void 0,
                { top: true }
              ]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Listbox, {
          class: "kn-list workflowContainer",
          options: _ctx.availableUsersList[1],
          filter: true,
          filterPlaceholder: _ctx.$t('common.search'),
          optionLabel: "name",
          filterMatchMode: "contains",
          filterFields: _ctx.workflowDescriptor.filterFields,
          emptyFilterMessage: _ctx.$t('common.info.noDataFound'),
          "data-test": "userList2"
        }, {
          empty: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
          ]),
          option: _withId((slotProps) => [
            _createVNode("div", {
              class: ["kn-list-item", { disableCursor: _ctx.isStartedWf }],
              onClick: ($event: any) => (_ctx.removeUserFromWfList(slotProps.option.id)),
              "data-test": "userList2-item"
            }, [
              _createVNode("div", _hoisted_7, [
                _createVNode("span", null, _toDisplayString(slotProps.option.userId), 1),
                _createVNode("span", _hoisted_8, _toDisplayString(slotProps.option.fullName), 1)
              ]),
              (!_ctx.isStartedWf)
                ? (_openBlock(), _createBlock("div", _hoisted_9, [
                    _createVNode(_component_Button, {
                      icon: "pi pi-arrow-circle-up",
                      class: "p-button-link",
                      onClick: _withModifiers(($event: any) => (_ctx.moveUpList(slotProps.option.id)), ["stop"])
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_Button, {
                      icon: "pi pi-arrow-circle-down",
                      class: "p-button-link",
                      onClick: _withModifiers(($event: any) => (_ctx.moveDownList(slotProps.option.id)), ["stop"])
                    }, null, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isStartedWf)
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    (slotProps.option.id === _ctx.userInProg)
                      ? (_openBlock(), _createBlock("i", {
                          key: 0,
                          class: "pi pi-check-circle",
                          style: _ctx.workflowDescriptor.style.icon
                        }, null, 4))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 10, ["onClick"])
          ]),
          _: 1
        }, 8, ["options", "filterPlaceholder", "filterFields", "emptyFilterMessage"])
      ])
    ])
  ]))
})